const defaultDictionary = {
	labelFindACruise: 'Find a cruise',
	actionAllFilters: 'All Filters',
	actionSearchCruises: 'Search cruises',
	labelAllFiltersApplied: 'applied',
	navCruiseDates: 'Cruise dates',
	homeNavCruiseDates: 'Any date',
	homeNavTopCruiseDates: 'Leaving on',
	navCruiseType: 'Cruise Type',
	subtitleCruiseType: 'Cruise Type',
	navNights: 'Number of nights',
	homeNavNights: 'Any duration',
	homeNavTopNights: 'Cruise duration',
	navDestination: 'Destinations',
	homeNavDestination: 'Anywhere',
	homeNavTopDestination: 'Cruising to',
	labelUniqueDestination: 'Featured destinations',
	labelUniqueRiverDestination: 'Rivers',
	labelSpecialDates: 'Special dates',
	navDeparturePort: 'Departure Port',
	homeNavDeparturePort: 'Any port',
	homeNavTopDeparturePort: 'Leaving from',
	navShips: 'Ships',
	homeNavShips: 'Any ship',
	homeNavTopShips: 'Sailing onboard',
	navMyOffers: 'My Offers',
	actionClearAll: 'Clear all',
	labelSoldOut: 'Sold out',
	actionModalResetFilters: 'Reset',
	actionModalSeeResults: 'See results',
	actionForMoreInformation: 'For more information',
	labelNightsSelected: 'Selected',
	labelLengthOfCruise: 'Length of cruise',
	labelAllDestinations: 'All destinations',
	labelDestinationsHeader: 'Destinations',
	inputDestinationSearchPlaceholder: 'Search for destinations like Bahamas',
	labelAllPorts: 'All ports',
	inputDeparturePortSearchPlaceholder: 'Search for departure ports',
	labelAllOurShips: 'All our ships',
	inputShipsSearchPlaceholder: 'Search for ships',
	labelDestinationAppender: 'Cruise',
	labelShipAppender: 'Ship',
	labelNightsAppender: 'Nights',
	labelPortsAppender: 'ports',
	labelPortAppender: 'port',
	labelOffersLogIn: 'Log in to see your exclusive discounts',
	inputOffersEnterEmailOrCrownAndAnchorSocietyID: 'Enter your email or Crown & Anchor Society ID',
	inputOffersEnterCrownAndAnchorSocietyID: 'Enter your Crown & Anchor Society ID',
	inputOffersLoyaltyOrEmailPlaceholder: 'email@email.com or 123456789',
	inputMyOffersLoyaltyInputPlaceholder: '123456789',
	actionMyOffersSignIn: 'Sign in',
	actionMyOffersForgotCASID: 'Forgot your Crown & Anchor Society number?',
	errorMyOffersInvalidCrownAndAnchorSocietyID: 'Invalid Crown and Anchor number. Please try again.',
	errorMyOffersInvalidEmail: 'Invalid email. Please try again.',
	actionMyOffersPill: 'Log in to unlock the best available rate',
	labelPromoCardPerkPrefix: ', ',
	actionSeeResults: 'See results',
	actionSeeMyOffers: 'See my offers',
	actionModalReset: 'Reset',
	actionModalApply: 'Apply',
	actionModalResetAll: 'Reset all',
	labelTargetedOffersLoggedAS: 'Exclusive Offers for:',
	labelTargetedOffersWelcomeBack: 'Thanks for logging in. You now have the best available rate.',
	labelTargetedOffersShowOffers: 'Here are your offers',
	labelTargetedOffersNoOffers: 'You don’t have any offers right now,\n but you are getting the best available rate today.',
	labelTargetedOffersNoOffersEmail:
		'You’re getting the best available rate today.\n If you have a Crown & Anchor Society number you may have more deals waiting.',
	labelTargetedOffersPrelinkCrownAnchor: 'You can also use your',
	actionTargetedOfferslinkCrownAnchor: 'Crown & Anchor ID to sign in',
	actionTargetedOffersSignIn: 'Sign in now.',
	errorTargetedOfferssForgotCASNotFound:
		'The information entered does not match any existing members on file. Please contact a Crown & Anchor representative',
	errorTargetedOfferssForgotCASErrorTitle: 'We encountered an error',
	errorTargetedOfferssForgotCASErrorMessage: 'There was an error retrieving your information. Please try again.',
	labelTargetedOffersExpiresToday: 'Expires today',
	labelTargetedOffersExpiresSoon: 'Expires soon',
	labelTargetedOffersIncompatible: 'Incompatible',
	labelTargetedOffersCurrentyApplied: 'Currently applied',
	actionTargetedOffersCurrentyTermsConditions: 'Terms and Conditions apply',
	labelTargetedOffersCurrentyOfferExpiresOn: 'Offer expires on',
	labelTargetedOffersWithPromoCode: 'with promo code',
	actionTargetedOffersSwitchAccount: 'switch accounts',
	labelTargetedOffersExpiresTitleToday: 'Your exclusive offer expires today: {0}',
	labelTargetedOffersExpiresTitleSoon: 'Your exclusive offer expires soon: {0}',
	labelTargetedOffersTitleSoldOut: 'There are no itineraries for this offer at the moment.',
	actionTargetedOffersShopThisOffer: 'Shop this offer',
	labelTargetedOffersAllGuestWithPromo: 'All Guests with promo code: {0}',
	labelTargetedOffersDescriptionSoldOut: 'We don’t have any itineraries for this offer now, but we still have great cruises you can choose from.',
	labelTargetedOffersProblemRetrievingYourOffers: 'There was a problem retrieving your offers.',
	labelPromoCardListLastDivider: '&',
	actionTargetedOffersRetry: 'Retry',
	labelTargetedOffersExpiringSoon: 'You have offers expiring soon',
	labelCasinoRoyaleOffer: 'High five! You have an exclusive offer',
	labelCasinoOfferJackpot: 'Your discount will be reflected at checkout.',
	labelFilterby: 'Filter by',
	labelMonths: 'Months',
	labelDateRange: 'Date Range',
	labelSelectByMonths: 'Search by Months',
	labelSelectByDates: 'Search by Dates',
	labelSelectByRegions: 'Regions',
	labelSelectByPorts: 'Ports',
	labelSelectOfAll: 'Select of all',
	labelDeparturePortPrepender: 'From',
	labelCouponPrepender: 'Coupon',
	labelCurrentOffers: 'Current Offers',
	labelRiverOffers: 'River Offers',
	labelPromoPrepender: 'Promo',
	labelOffersLogged: 'Offers for:',
	labelOffersWelcomeBack: 'Thanks for logging in.',
	labelOffersTierTitle: "We don't have any special offers right now.",
	labelOffersTierSubtitle: 'Regardless, as a {tierName} member,',
	labelOffersRateSubtitle: 'you are receiving a special reduced rate.',
	labelOffersCASSubtitle: 'Crown & Anchor Society {tierName} members also enjoy:',
	labelLoyaltyTierGoldPerk:
		'Exclusive onboard offers|Extra cruise points for booking a Suite|Exclusive email offers|Priority notice on special offers, new ships, and itineraries',
	labelLoyaltyTierPlatinumPerk:
		'Invitation to exclusive onboard events|Extra cruise points for booking a Suite|Discounts on Balcony and Suite staterooms|Robes for use onboard',
	labelLoyaltyTierEmeraldPerk:
		'Lapel pin recognition and invitation to exclusive onboard events|Extra cruise points for booking a Suite|Discounts on balconv and suite staterooms|Complimentary welcome waters upon arrival',
	labelLoyaltyTierDiamondPerk:
		'Complimentary daily drink vouchers|Exclusive events and milestone recognition|Priority wait list for sold out shore excursions & spa services|Complimentary welcome waters upon arrival',
	labelLoyaltyTierDiamondPlusPerk:
		'Complimentary daily drink Vouchers|Priority Access for Theater, Ice Show, and AquaTheater events|Priority wait list for sold out shore excursions & spa services|Exclusive Rise & Shine Coffee Social',
	labelLoyaltyTierPinnacleClubPerk: 'Flexible arrival at check-in|Exclusive daily breakfast|Crown Lounge Access|Milestone cruise certificates',
	inputPortsLabel: 'Search for ports',
	inputPortsPlaceholder: 'Type in a port location',
	navNumberOfGuests: 'Number of guests',
	homeNavNumberOfGuests: 'Anyone',
	homeNavTopNumberOfGuests: "Who's going",
	labelFilterAdults: 'Ages 13 and older',
	labelFilterChildren: 'Ages 12 and under',
	labelNumberOfGuests: 'If you have more than 4 guests, you can book multiple staterooms.',
	labelFilterChildren_CEL: 'Ages 17 and under',
	labelFilterChildren_RCI: 'Ages 12 and under',
	labelUniqueOffers: 'Unique cruise offers',
	navSpecialSailings: 'Special sailings',
	labelFiltersApplied: 'Filters applied:',
	labelExpand: 'Expand',
	labelCollapse: 'Collapse',
	labelMore: '{0} more',
	labelAdult: 'Adult',
	labelAdults: 'Adults',
	labelChild: 'Child',
	labelChildren: 'Children',
	labelChildrenDisclaimer: 'Under 12 years',
	labelAllFiltersSelected: 'All filters selected:',
	labelSpecialShips: 'Iconic Vacations',
};

export default defaultDictionary;
